// import LinkWithSearchParams from "../UI/LinkWithSearchParams";
import { FaDiscord } from "react-icons/fa";
import { BiRightArrowAlt } from "react-icons/bi";

import StripesSvg from "../../assets/images/home/Stripes.svg";
import shappe_1 from "../../assets/images/home/shape_01.png";
import shappe_2 from "../../assets/images/home/shape_02.png";
import shappe_3 from "../../assets/images/home/shape_03.png";
import shappe_4 from "../../assets/images/home/shape_04.png";
import shappe_5 from "../../assets/images/home/shape_05.png";
import shappe_6 from "../../assets/images/home/shape_06.png";

import team_1 from "../../assets/images/home/teams/team-1.png";
import team_2 from "../../assets/images/home/teams/team-2.png";
import team_3 from "../../assets/images/home/teams/team-3.png";
import team_4 from "../../assets/images/home/teams/team-4.png";
import team_5 from "../../assets/images/home/teams/team-5.png";

import tag_privatesale from "../../assets/images/home/tag-privatesale.svg";
import tag_note from "../../assets/images/home/tag-note.svg";
import tag_lightning from "../../assets/images/home/tag-lightning.svg";

import landing_users from "../../assets/images/home/landing-users.png";

import LinkWithSearchParams from "../UI/LinkWithSearchParams";
import { HiArrowRight } from "react-icons/hi";

const LandingMain = () => {
  return (
    <>
      <img
        src={StripesSvg}
        alt="stripe background"
        className="absolute left-0 top-4 md:top-[70px] w-screen object-cover"
        style={{ height: "calc(100vh - 160px)" }}
      />
      <div className="flex flex-col animation-fade-in lg:pl-8 lg:pt-48 pt-16 pb-24 relative">
        {heading_shapes.map((item, index) => (
          <img
            key={index}
            alt="shape"
            className={`absolute ${item.class}`}
            src={item.image}
            draggable="false"
          />
        ))}
        <div className="flex flex-col md:flex-row items-center md:justify-around">
          <div>
            <span className="size-2 drop-shadow-xl font-normal lg:w-2/3 mt-8">
              GET STARTED AND ENJOY THE ALL NEW
            </span>
            <h2 className="text-50 drop-shadow-xl tracking-wider leading-tight z-[1]">
              SOCIAL PAD
            </h2>
          </div>
          <div className="flex flex-col items-center gap-4 rounded-lg bg-[#140A28] shadow-lg p-14 pb-8">
            <span className="size-2">JOIN THE COMMUNITY</span>
            <div className="flex flex-col gap-6">
              <div className="flex items-center">
                <font className="text-kad-gradient size-1 font-bold mr-4">
                  01
                </font>
                <span>Connect with your Wallet</span>
              </div>
              <div className="flex items-center">
                <font className="text-kad-gradient size-1 font-bold mr-4">
                  02
                </font>
                <span>Setup your Profile</span>
              </div>
              <div className="flex items-center">
                <font className="text-kad-gradient size-1 font-bold mr-4">
                  03
                </font>
                <span>Level up and Earn Rewards</span>
              </div>
            </div>
            <div className="h-1 w-full rounded-lg bg-white/20" />
            <LinkWithSearchParams
              to={{
                pathname: "/profile",
              }}
              className="blueGradient-button button flex items-center px-4 mt-4 rounded-lg"
            >
              <HiArrowRight className="size-2" />
              <div className="h-6 mx-2 w-1 bg-white/20" />
              <span>GET STARTED NOW</span>
            </LinkWithSearchParams>
            <div className="article-tag mr-2">What is Kadido</div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center lg:pt-16 relative">
        <div className="flex items-center gap-3 lg:pl-12">
          <h3 className="text-30">IDEA</h3>
          <div className="w-3 h-3 rounded-full bg-kadido-gr" />
          <h3 className="text-30">CREATE</h3>
          <div className="w-3 h-3 rounded-full bg-kadido-gr" />
          <h3 className="text-30">LAUNCH</h3>
        </div>
        <div className="flex flex-row flex-wrap lg:flex-nowrap items-center w-full lg:px-16">
          <img
            className="basis-1/2"
            alt="landing page users"
            src={landing_users}
            draggable="false"
          />
          <div className="flex flex-col gap-6 lg:basis-1/2 p-4">
            <div className="relative flex">
              <span className="ribbon absolute -top-1/2 -left-4">
                Our Mission
              </span>
              <div className="rounded-lg py-3 px-16 bg-kadido-gr size-2">
                What's Kadido?
              </div>
            </div>
            <p className="opacity-70">
              Every digital creation is issued as a unique digital edition.
              Using blockchain technology, a creator can ensure that only a
              limited number of authentic editions can ever be owned, ensuring
              scarcity and uniqueness of a digital creation.
            </p>
            <button className="bg-white text-black rounded-lg px-8 w-fit">
              Learn more
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center pt-16 pb-24 relative">
        <h3 className="size-4">WHAT WE OFFER</h3>
        <p className="text-[16px] text-center py-2">
          Meet some of the main faces behind the flowbase products!
        </p>
        <div className="flex flex-wrap gap-4 justify-center pt-8">
          <div className="flex flex-col w-88 items-center p-8 bg-kadItemDarkBg rounded-lg">
            <img
              alt="tag private sale"
              className="w-24"
              src={tag_privatesale}
              draggable="false"
            />
            <h5 className="font-medium py-4">Private Sale</h5>
            <p className="font-normal text-center">
              Online and always available, we’re here to answer your questions
              24/7
            </p>
            <button className="hover-gradient-button px-8 rounded-full mt-8">
              Create
              <BiRightArrowAlt className="size-2" />
            </button>
          </div>
          <div className="flex flex-col w-88 items-center p-8 bg-kadItemDarkBg rounded-lg">
            <img
              alt="tag private sale"
              className="w-24"
              src={tag_note}
              draggable="false"
            />
            <h5 className="font-medium py-4">Private Sale</h5>
            <p className="font-normal text-center">
              Online and always available, we’re here to answer your questions
              24/7
            </p>
            <button className="hover-gradient-button px-8 rounded-full mt-8">
              Learn More
              <BiRightArrowAlt className="size-2" />
            </button>
          </div>
          <div className="flex flex-col w-88 items-center p-8 bg-kadItemDarkBg rounded-lg">
            <img
              alt="tag private sale"
              className="w-24"
              src={tag_lightning}
              draggable="false"
            />
            <h5 className="font-medium py-4">Private Sale</h5>
            <p className="font-normal text-center">
              Online and always available, we’re here to answer your questions
              24/7
            </p>
            <button className="hover-gradient-button px-8 rounded-full mt-8">
              Contract Support
              <BiRightArrowAlt className="size-2" />
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center pb-24 relative w-full">
        <h3 className="size-4">KADIDO TEAM</h3>
        <p className="text-[16px] text-center py-2">
          Meet some of the main faces behind the flowbase products!
        </p>
        <div className="flex flex-wrap justify-around gap-y-3 pt-8 w-full">
          {team_members.map((member, index) => (
            <div
              key={index}
              className="flex flex-col md:w-56 w-full items-center p-8 bg-kadItemDarkBg rounded-lg"
            >
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-[#FFFFFF14]">
                <img
                  alt={`${member.name} ${member.title}`}
                  className="w-20"
                  src={member.image}
                  draggable="false"
                />
              </div>
              <h5 className="font-semibold pt-4 text-[17px]">{member.name}</h5>
              <p className="font-normal text-center opacity-70 text-[12px]">
                {member.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div
        className="hidden w-full lg:mt-40 pb-8 lg:pb-24 relative bg-gradient-to-r from-blueGrSt to-blueGrEd overflow-hidden"
        id="connect_us_div"
      >
        <div className="absolute left-0 top-0 w-full h-full bg-community-mask"></div>
        <FaDiscord className="w-16 h-16 lg:w-32 lg:h-32 left-0 top-0 rotate-[60deg] absolute fill-white" />
        <FaDiscord className="w-16 h-16 lg:w-32 lg:h-32 right-0 bottom-0 absolute fill-white" />
        <div className="flex flex-col items-center relative z-[1]">
          <h1 className="font-yukita font-bold text-white text-center py-8 lg:py-12">
            Join the community
          </h1>
          <span className="size-1 text-white text-center px-8">
            Join our DAO Discord Community, warmly introduce yourself, and
            connect with other Dapp builders!
          </span>
          <div className="w-11/12 lg:w-2/3 flex flex-col mt-6 p-6 bg-white rounded-lg shadow-xl">
            <span className="text-darkGray size-1">Email</span>
            <div className="flex flex-col lg:flex-row gap-4 pt-4">
              <input
                className="rounded-lg w-full bg-darkGray bg-opacity-10 size-base pl-4 py-4"
                placeholder="Enter email"
              />
              <button className="blueGradient-button w-2/3 lg:w-80 py-4 lg:py-6 mx-auto size-base">
                Explore More
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingMain;

const heading_shapes = [
  {
    image: shappe_1,
    class: "top-12 lg:-right-28 right-0",
  },
  {
    image: shappe_2,
    class:
      "-bottom-32 lg:-left-32 left-0 animate-[particle-movement-2_2s_ease-in-out_infinite]",
  },
  {
    image: shappe_3,
    class:
      "lg:top-16 top-14 lg:-right-16 right-12 animate-[particle-movement-1_2s_ease-in-out_infinite]",
  },
  {
    image: shappe_4,
    class: "lg:-left-8 animate-[particle-movement-3_2s_ease-in-out_infinite]",
  },
  {
    image: shappe_5,
    class:
      "bottom-16 lg:right-32 right-8 animate-[particle-movement-2_2s_ease-in-out_infinite]",
  },
  {
    image: shappe_6,
    class:
      "-bottom-16 -left-8 animate-[particle-movement-3_2s_ease-in-out_infinite]",
  },
];

const team_members = [
  {
    image: team_1,
    name: "Samuel",
    title: "Co-Founder & PM",
  },
  {
    image: team_2,
    name: "Brendan",
    title: "Co-Founder & CTO",
  },
  {
    image: team_4,
    name: "Erkki",
    title: "Sr. Web3 Lead",
  },
  {
    image: team_5,
    name: "Sam-Vink",
    title: "Sr. Backend Engineer",
  },
  {
    image: team_3,
    name: "Jose",
    title: "Community Manager",
  },
];
